var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('video');
import { breakpoints } from '@shapeable/theme';
import { VideoPlayer } from '../elements/video-player';
import { ResponsiveContainer } from '../elements/responsive-container';
export var VideoDefaultProps = {
  aspectRatio: {
    base: 16 / 9
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.hasAspectRatio && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 100%;\n      width: 100%;\n    "], ["\n      height: 100%;\n      width: 100%;\n    "])));
  })
});
var PlayerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.hasAspectRatio && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: 100%;\n      width: 100%;\n    "], ["\n      height: 100%;\n      width: 100%;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Player: styled(VideoPlayer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), PlayerStyles)
};
export var Video = function (props) {
  var className = props.className,
    entity = props.entity,
    aspectRatio = props.aspectRatio;
  return React.createElement(My.Container, {
    hasAspectRatio: !!aspectRatio,
    className: cls.name(className)
  }, aspectRatio ? React.createElement(ResponsiveContainer, {
    aspectRatio: aspectRatio
  }, React.createElement(My.Player, {
    hasAspectRatio: !!aspectRatio,
    url: entity.url
  })) : React.createElement(My.Player, {
    hasAspectRatio: !!aspectRatio,
    url: entity.url
  }));
};
Video.defaultProps = VideoDefaultProps;
Video.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;